import axios from 'axios';

const getTaxReturn = ({ id, companyId }) => {
  return axios.get(`/tax_returns/${id}`, {
    params: {
      company_id: companyId,
    },
  });
};

const getTaxReturns = ({ companyId, year }) => {
  return axios.get('/tax_returns', {
    params: {
      company_id: companyId,
      year,
    },
  });
};

const getActivityLogs = ({ id, companyId }) => {
  return axios.get(`/tax_returns/${id}/get_activity_logs`, {
    params: {
      company_id: companyId,
    },
  });
};

const saveSignature = ({
  id,
  companyId,
  formIndex,
  signatureIndex,
  signatureType,
  signatureData,
  signatureDate,
  sessionId,
  userId,
  title,
  name,
  email,
  signatureLeft,
  signatureBottom,
  signatureWidth,
  signatureHeight,
}) => {
  return axios.post(`/tax_returns/${id}/save_signature`, {
    company_id: companyId,
    form_index: formIndex,
    signature_index: signatureIndex,
    signature: {
      signatureType: signatureType,
      signatureData: signatureData,
      signatureDate: signatureDate,
      signatureLeft: signatureLeft,
      signatureBottom: signatureBottom,
      signatureWidth: signatureWidth,
      signatureHeight: signatureHeight,
      userId,
      title,
      name,
      email,
    },
    session_id: sessionId,
  });
};

const createCheckoutSession = ({ id, companyId }) => {
  return axios.post(`/tax_returns/${id}/create_checkout_session`, {
    company_id: companyId,
  });
};

const verifyCheckoutSession = ({ id, companyId }) => {
  return axios.post(`/tax_returns/${id}/verify_checkout_session`, {
    company_id: companyId,
  });
};

const sendToDocuments = ({
  id,
  companyId,
  subject,
  message,
  documentName,
  path,
  saveSubjectForFutureUse,
  saveMessageForFutureUse,
}) => {
  return axios.post(`/tax_returns/${id}/send_to_documents`, {
    company_id: companyId,
    subject,
    message,
    document_name: documentName,
    path: path,
    save_subject_for_future_use: saveSubjectForFutureUse,
    save_message_for_future_use: saveMessageForFutureUse,
  });
};

const downloadTaxReturn = ({ id, companyId, includeOtherPages = false }) => {
  return axios.post(`/tax_returns/${id}/download_tax_return`, {
    company_id: companyId,
    include_other_pages: includeOtherPages,
  });
};

const getOriginalImages = ({ id, companyId }) => {
  return axios.get(`/tax_returns/${id}/get_original_images`, {
    params: {
      company_id: companyId,
    },
  });
};

const updateTaxReturn = ({ id, companyId, ...data }) => {
  return axios.patch(`/tax_returns/${id}`, {
    company_id: companyId,
    ...data,
  });
};

const getEstimatedOcrTime = ({ id, companyId }) => {
  return axios.get(`/tax_returns/${id}/get_estimated_ocr_time`, {
    params: {
      company_id: companyId,
    },
  });
};

const getUploadLinkForPaymentVoucher = ({ companyId }) => {
  return axios.get(`/tax_returns/get_upload_link_for_payment_voucher`, {
    params: {
      company_id: companyId,
    },
  });
};

const processPaymentVoucher = ({
  fileId,
  companyId,
  taxReturnId,
  documentName,
}) => {
  return axios.post(`/tax_returns/${taxReturnId}/process_payment_voucher`, {
    file_id: fileId,
    company_id: companyId,
    document_name: documentName,
  });
};

const getUploadLinkForPaperFiledReturn = ({ companyId }) => {
  return axios.get(`/tax_returns/get_upload_link_for_paper_filed_return`, {
    params: {
      company_id: companyId,
    },
  });
};

const getDownloadLinkForPaperFiledReturn = ({ companyId, documentPath }) => {
  return axios.get(`/tax_returns/get_download_link_for_paper_filed_return`, {
    params: {
      company_id: companyId,
      document_path: documentPath,
    },
  });
};

const processPaperFiledReturn = ({
  fileId,
  companyId,
  taxReturnId,
  documentName,
}) => {
  return axios.post(`/tax_returns/${taxReturnId}/process_paper_filed_return`, {
    file_id: fileId,
    company_id: companyId,
    document_name: documentName,
  });
};

const getUploadLinkForK1Package = ({ companyId }) => {
  return axios.get(`/tax_returns/get_upload_link_for_k1_package`, {
    params: {
      company_id: companyId,
    },
  });
};

const processK1Package = ({ fileId, companyId, taxReturnId, documentName }) => {
  return axios.post(`/tax_returns/${taxReturnId}/process_k1_package`, {
    file_id: fileId,
    company_id: companyId,
    document_name: documentName,
  });
};

const getK1PackageDownloadLink = ({ token }) => {
  return axios.get(`/tax_returns/get_k1_package_download_link`, {
    params: {
      token: token,
    },
  });
};

export default {
  getTaxReturn,
  getTaxReturns,
  getActivityLogs,
  saveSignature,
  createCheckoutSession,
  verifyCheckoutSession,
  sendToDocuments,
  downloadTaxReturn,
  getOriginalImages,
  updateTaxReturn,
  getEstimatedOcrTime,
  getUploadLinkForPaymentVoucher,
  processPaymentVoucher,
  getUploadLinkForPaperFiledReturn,
  getDownloadLinkForPaperFiledReturn,
  processPaperFiledReturn,
  getUploadLinkForK1Package,
  processK1Package,
  getK1PackageDownloadLink,
};
